import { FC, ReactElement, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container } from 'react-bootstrap';
import ITraining from '../../domain/interfaces/api/ITraining';
import './Training.css';
import TrainingElement from './TrainingElement';
import TopBar from './TopBar';
import { ServiceTypeEnum } from '../../domain/enums/ServiceTypeEnum';
import IMetadata from '../../domain/interfaces/api/IMetadata';
import { useHistory } from 'react-router';
import apiAxios from '../../services/api-axios';

const TrainingSections: FC<{}> = (props): ReactElement => {
  const { t } = useTranslation();

  const [training, setTraining] = useState<ITraining | null>(null);
  const [metadata, setMetadata] = useState<IMetadata | null>(null);

  let history = useHistory();

  useEffect(() => {
    apiAxios
      // apiServices
      .getTraining()
      .then((response) => {
        setTraining(response.data);
        // setTraining(response);
      })
      .catch((error) => {
        console.log(error);
      });

    apiAxios
      // apiServices
      .getMetadata()
      .then((response) => {
        setMetadata(response.data);
        // setMetadata(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleSearchAndFlters = (
    type: ServiceTypeEnum,
    searchTerm?: string,
    category?: string,
    teacher?: string
  ) => {
    history.push(`/${type}/${searchTerm || 'null'}/${category}/${teacher}`);
  };

  return (
    <Col>
      <Container
        fluid="xxl"
        className="px-0"
        style={{ marginTop: 200, marginBottom: 200 }}
      >
        {/* Filter row */}
        {/* <div className='d-flex flex-wrap px-3 justify-content-evenly'>
        <Button className='filter-btn'>Nieruchomości</Button>
        <Button className='filter-btn'>Księgowość </Button>
        <Button className='filter-btn'>Ochrona Środowiska</Button>
        <Button className='filter-btn'>OPS</Button>
        <Button className='filter-btn'>Odpady</Button>
        <Button className='filter-btn'>USC</Button>
        <Button className='filter-btn'>Szkoły</Button>
        <Button className='filter-btn'>Informatyka</Button>
      </div> */}
      </Container>

      {/* Consultancy elements */}
      <TrainingElement
        elements={training && training.consultations}
        nrelements={training && training.nr_consultations}
        background="/img/consultation_background.png"
        title={t('components.consultancy.title')}
        topbar={
          <TopBar
            type={ServiceTypeEnum.CONSULTANCY}
            handleSearchAndFlters={(
              searchTerm?: string,
              category?: string,
              teacher?: string
            ) =>
              handleSearchAndFlters(
                ServiceTypeEnum.CONSULTANCY,
                searchTerm,
                category,
                teacher
              )
            }
            categoryItems={metadata?.departments || []}
            teacherItems={metadata?.instructors || []}
          />
        }
        type={ServiceTypeEnum.CONSULTANCY}
      />

      {/* Video elements */}
      {/* <div style={{ marginTop: 250 }}></div> */}
      <TrainingElement
        elements={training && training.videos}
        nrelements={training && training.nr_videos}
        background="/img/video_background.png"
        title={t('components.videos.title')}
        topbar={
          <TopBar
            type={ServiceTypeEnum.VIDEO}
            handleSearchAndFlters={(
              searchTerm?: string,
              category?: string,
              teacher?: string
            ) =>
              handleSearchAndFlters(
                ServiceTypeEnum.VIDEO,
                searchTerm,
                category,
                teacher
              )
            }
            categoryItems={metadata?.departments || []}
            teacherItems={metadata?.instructors || []}
          />
        }
        type={ServiceTypeEnum.VIDEO}
      />
    </Col>
  );
};

export default TrainingSections;
